<template>
  <tr v-if="item.name == 'total'" class="totalRow">
    <td>
      <b>
        <h3>Total</h3>
      </b>
    </td>
    <td>
      <b>
        <h3></h3>
      </b>
    </td>
    <td>
      <b>
        <h3></h3>
      </b>
    </td>
    <td>
      <b>
        <h3></h3>
      </b>
    </td>
    <td>
      <b>
        <h4 class="success--text font-weight-bold totalField">
          {{ item["totalAmount"] || 0 | amount }}
        </h4>
      </b>
    </td>
    <!-- <td>
      <b>
        <h4 class="font-weight-bold">
          {{ Number.parseFloat(Number.parseFloat(item.totalAmount - (item.totalExtraCharges || 0 | amount) - (item.roundOffAmount || 0 | amount)) - getGSTtotal(item)) || 0 | amount}}
        </h4>
      </b>
    </td> -->
    <td>
      <b>
        <h4 class="font-weight-bold totalField">
          <!-- {{ item["totalAmount"] - item["gstTotal"] || 0 | amount }} -->
          {{ item["basicAmount"] || 0 | amount }}
        </h4>
      </b>
    </td>
    <td>
      <b>
        <h4 class="font-weight-bold totalField">{{ item["gstTotal"] || 0 | amount }}</h4>
      </b>
    </td>
     <td>
      <b class="totalField">{{ item.totalExtraCharges || 0 | amount }}</b>
    </td>
    <td>
      <b>
        <h4 class="font-weight-bold totalField">
          {{ item["discountAmount"] || 0 | amount }}
        </h4>
      </b>
    </td>
    <td>
      <b>
        <h4 class="primary--text font-weight-bold totalField">
          {{ item["paidAmount"] || 0 | amount }}
        </h4>
      </b>
    </td>
    <td>
      <b>
        <h4 class="error--text font-weight-bold totalField">
          {{ item["remainingAmount"] || 0 | amount }}
        </h4>
      </b>
    </td>
    <td>
      <b>
        <h3></h3>
      </b>
    </td>
    <td>
      <b>
        <h3></h3>
      </b>
    </td>
      <td>
      <b>
        <h3></h3>
      </b>
    </td>
    <td>
      <b>
        <h4></h4>
      </b>
    </td>
    <td>
      <b>
        <h4 class="font-weight-bold totalField"></h4>
      </b>
    </td>
    <td>
      <b>
        <h4 class="font-weight-bold totalField"></h4>
      </b>
    </td>
    <td>
      <b>
        <h4 class="font-weight-bold totalField"></h4>
      </b>
    </td>
    <td>
      <b>
        <h4 class="primary--text font-weight-bold totalField">
          {{ item["GST_3"] || 0 | amount }}
        </h4>
      </b>
    </td>
    <td>
      <b>
        <h4 class="primary--text font-weight-bold totalField">
          {{ item["GST_5"] || 0 | amount }}
        </h4>
      </b>
    </td>
    <td>
      <b>
        <h4 class="primary--text font-weight-bold totalField">
          {{ item["GST_12"] || 0 | amount }}
        </h4>
      </b>
    </td>
    <td>
      <b>
        <h4 class="primary--text font-weight-bold totalField">
          {{ item["GST_18"] || 0 | amount }}
        </h4>
      </b>
    </td>
    <td>
      <b>
        <h4 class="primary--text font-weight-bold totalField">
          {{ item["GST_28"] || 0 | amount }}
        </h4>
      </b>
    </td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  <tr v-else>
    <!-- <td><b>{{new Date(item.date).toLocaleDateString('en-GB')}}</b></td> -->
    <!-- <td>
        <b>{{ item['.key']}}</b>
    </td> -->
    <td
      class="primary--text font-weight-bold"
      v-html="renderDate(item.date)"
    ></td>
    <td>
      <v-menu offset-y :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">more_vert</v-icon>
        </template>
        <v-list>
          <v-list-tile @click="openProd(item)">
            <v-list-tile-title class="font-weight-bold primary--text">
              <v-icon class="primary--text">
                remove_red_eye
              </v-icon>
              View
            </v-list-tile-title>
          </v-list-tile>
          <v-list-group
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title class="font-weight-bold primary--text">
                    <v-icon class="primary--text">
                      remove_red_eye
                    </v-icon>
                    Print
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

              <v-list-tile @click="printBasicInvoice(item)">
                <v-list-tile-avatar>
                  <v-icon color="primary">panorama_vertical</v-icon>
                    </v-list-tile-avatar>
                <v-list-tile-title>Basic Print</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                @click="printInvoice4(item)">
                <v-list-tile-avatar>
                  <v-icon color="primary">panorama_wide_angle</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-title>
                  Simple Print
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                @click="printHorizontalInvoice(item)"
              >
               <v-list-tile-avatar>
                          <v-icon color="primary">panorama_horizontal</v-icon>
                        </v-list-tile-avatar>
                <v-list-tile-title>Detailed Print</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="printDairyInvoice(item)">
                <v-list-tile-avatar>
                  <v-icon color="primary">mdi-receipt</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-title>Theme1 Print</v-list-tile-title>
              </v-list-tile>
              <!-- <v-list-tile @click="printBasicDairyInvoice(item)">
                <v-list-tile-avatar>
                  <v-icon color="primary">panorama_vertical</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-title>Theme2 Print</v-list-tile-title>
              </v-list-tile> -->
              <!-- <v-list-tile
                @click="printEwayType1(item)"
                v-if="item.ewayBillDetails"
              >
               <v-list-tile-avatar>
                          <v-icon color="primary">looks_one</v-icon>
                        </v-list-tile-avatar>
                <v-list-tile-title>Excessive Print</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                @click="printEwayType2(item)"
                v-if="item.ewayBillDetails"
              >
               <v-list-tile-avatar>
                          <v-icon color="primary">looks_two</v-icon>
                        </v-list-tile-avatar>
                <v-list-tile-title>Extravagent Print</v-list-tile-title>
              </v-list-tile> -->
              <v-list-tile
                @click="printEwayType3(item)"
                v-if="item.ewayBillDetails"
              >
               <v-list-tile-avatar>
                  <v-icon color="primary">aspect_ratio</v-icon>
                    </v-list-tile-avatar>
                <v-list-tile-title>Exclusive Print</v-list-tile-title>
              </v-list-tile>
          </v-list-group>
          <v-list-tile>
            <router-link
              style="text-decoration: none"
              :to="{
                name: 'InvoiceUpdate',
                params: { invoiceId: item['.key'] },
              }"
            >
              <v-list-tile-title class="font-weight-bold primary--text">
                <v-icon class="primary--text">
                  edit
                </v-icon>
                Edit
              </v-list-tile-title>
            </router-link>
          </v-list-tile>
          <v-list-tile>
            <router-link
              style="text-decoration: none"
              :to="'/invoice-statements/' + item.buyerId"
            >
              <v-list-tile-title class="font-weight-bold primary--text">
                <v-icon class="primary--text">
                  fact_check
                </v-icon>
                Statement
              </v-list-tile-title>
            </router-link>
          </v-list-tile>
        </v-list>
      </v-menu>
    </td>
    
    <td>
      <b>
        <router-link
          style="text-decoration: none"
          :to="'/buyers/' + item.buyerId"
        >
        {{ buyerById(item.buyerId).name }}
        </router-link>
      </b>
    </td>
    <td>
      <b>{{ item["invoiceId"] }}</b>
    </td>
    <td>
      <b class="success--text font-weight-bold">{{
        item["totalAmount"] || 0 | amount
      }}</b>
    </td>
    <!-- <td>
      <b>{{ (((item["totalAmount"]) - (item["roundOffAmount"] || 0 | amount)) - getGSTtotal(item)) || 0 | amount }}</b>
    </td> -->
    <td class="nowrap">
      <!-- <b class="text-xs-left "> {{ ((item.totalAmount - (item.totalExtraCharges || 0 | amount) - (item.roundOffAmount || 0 | amount)) - getGSTtotal(item)) || 0 | amount}}</b></td> -->
      <b class="text-xs-left "> {{ ((item.totalAmount - (item.totalExtraCharges || 0 ) - (item.roundOffAmount || 0 )) - getGSTtotal(item)) || 0 | amount}}</b></td>
    <td>
      <b>{{ getGSTtotal(item) || 0 | amount }}</b>
    </td>
    <td>
      <b>{{ item.totalExtraCharges || 0 | amount }}</b>
    </td>
    <td>
      <b>{{ item["discountAmount"] || 0 | amount }}</b>
    </td>
    <td>
      <b class="primary--text font-weight-bold">{{
        item["paidAmount"] || 0 | amount
      }}</b>
    </td>
    <td>
      <b class="error--text font-weight-bold">{{
        item["remainingAmount"] || 0 | amount
      }}</b>
    </td>
    <td>
      <b>{{ item["paymentType"] }}</b>
    </td>
    <td>
      <b>{{ item["status"] }}</b>
    </td>
    <!-- <td>
                    <b>{{ item['transactionType']}}</b>
                  </td> -->
    <td>
      <b>{{ item["gstType"] }}</b>
    </td>
    <td>
      <b>{{
        (item["gstType"] == "IGST" ? getGSTtotal(item) || 0 : 0) | amount
      }}</b>
    </td>
    <td>
      <b>{{
        (item["gstType"] == "SGST|CGST" ? getGSTtotal(item) / 2 || 0 : 0)
          | amount
      }}</b>
    </td>
    <td>
      <b>{{
        (item["gstType"] == "SGST|CGST" ? getGSTtotal(item) / 2 || 0 : 0)
          | amount
      }}</b>
    </td>
    <td>
      <b>{{
        item["GST_Percentage_total"]
          ? item["GST_Percentage_total"]["GST_3"]
          : "" || 0 | amount
      }}</b>
    </td>
    <td>
      <b>{{
        item["GST_Percentage_total"]
          ? item["GST_Percentage_total"]["GST_5"]
          : "" || 0 | amount
      }}</b>
    </td>
    <td>
      <b>{{
        item["GST_Percentage_total"]
          ? item["GST_Percentage_total"]["GST_12"]
          : "" || 0 | amount
      }}</b>
    </td>
    <td>
      <b>{{
        item["GST_Percentage_total"]
          ? item["GST_Percentage_total"]["GST_18"]
          : "" || 0 | amount
      }}</b>
    </td>
    <td>
      <b>{{
        item["GST_Percentage_total"]
          ? item["GST_Percentage_total"]["GST_28"]
          : "" || 0 | amount
      }}</b>
    </td>
    <td>
      <b>{{ item["duration"] }}</b>
    </td>
    <td>
      <b>{{ item["adminEmail"] ? item["adminEmail"] : "" }}</b>
    </td>
    <td>
      <b>{{ firmNameById(item.firm) }}</b>
    </td>
    <td>
      <b>{{ branchNameById(item.branch) }}</b>
    </td>
    <td>
      <b>{{ item.voucherType }}</b>
    </td>
  </tr>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { convertToBasicInvoice,convertToBasicInvoiceWithoutGST, convertToBasicInvoiceForDairyWithoutGST, convertToSimpleInvoicePrint,
convertToEwayBillType1,convertToEwayBillType2,convertToBasicInvoiceHorizontal,convertToEwayBillType3 } from "../../utils/pdfmake";

const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];


export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {
        };
      },
    },
    amount:0.00,
    isCredited: {
      type: Boolean,
      default: true,
    },
    firms: {
      type: Array,
      default: [],
    },
    // branchs: {
    //   type: Array,
    //   default: [],
    // },
    sellers: {
      type: Object,
      default: [],
    },
    buyers: {
      type: Object,
      default: [],
    },
    status: {
      type: Array,
      default: () => {
        return ["close"];
      },
    },
    firmAssignment: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: String,
      default: "",
    },
    selectedFirm: {
      type: String,
      default: null,
    },
    selectedDate: {
      type: String,
      default: () => {
        let today = new Date();
        return `${today.getFullYear()}-${
          today.getMonth() + 1
        }-${today.getDate()}`;
      },
    },
  },
  data: () => ({}),
  created() {
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("accounts", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("branchs", this.$root.$firebaseRefs.branch.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject(
      "productById",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand"]),
    firmsByBrand() {
      return this.firms.filter((item) => item["brand"] === this.selectedBrand);
    },
  },
  methods: {
    openProd(invoice) {
      this.$emit('openItems', invoice)
    },
    buyerById(id) {
      if (this.buyers[id]) {
        return this.buyers[id];
      } else if (this.sellers[id]) {
        return this.sellers[id];
      } else {
        return {
          name: "--",
        };
      }
    },
    async printBasicInvoice(selectedInvoice) {
      let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.accounts.filter(
              (item) => item[".key"] == bankId
            )[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firm
      )[0];
      firm.address = this.getAddress(firm);
      let customer = this.buyerById(selectedInvoice.buyerId);
      customer.address = this.getAddress(customer);
      // selectedInvoice['date'] = selectedInvoice['dateOfInvoice'];
      let gstInvoice = firm.GST_user && firm.GST_user == "Yes" ? true : false;
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
      let productObj = {};
        if(!gstInvoice && termsAndConditions[0].isMajorUnitDisplay) {
          selectedInvoice.items.map((item)=>{
            productObj[item['productId']] =  this.productById[item['productId']];
          })
        }
      let doc = gstInvoice
        ? await convertToBasicInvoice({
            invoiceData: selectedInvoice,
            firm: firm,
            customer: customer,
            gstTotal: gstTotal,
            terms: termsAndConditions[0],
          })
        : await convertToBasicInvoiceWithoutGST({
            invoiceData: selectedInvoice,
            firm: firm,
            customer: customer,
            gstTotal: gstTotal,
            terms: termsAndConditions[0],
            productObj : productObj
          });
      pdfMake.createPdf(doc).download(this.buyerById(selectedInvoice.buyerId).name);
    },

    // Start simple Print
    // async printInvoice4(selectedInvoice){
    //   let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
    //   if(termsAndConditions.length) {
    //     if(termsAndConditions[0].bank) {
    //     let banks = [];
    //     termsAndConditions[0].bank.map((bankId) =>{
    //       let bank = this.banks.filter(item => item['.key'] == bankId)[0]

    //       bank.address = this.getAddress(bank);
    //       banks.push(bank);
    //     })
    //     termsAndConditions[0].banks = banks;
    //   } else {
    //       termsAndConditions[0].banks = [];
    //     } 
    //   } else {
    //     termsAndConditions = [{
    //       termsAndConditions : "",
    //       banks: []
    //     }]
    //   }
    //     let firm = this.firms.filter(item => item['.key'] == selectedInvoice.firmID)[0]
    //     firm.address = this.getAddress(firm);
    //     this.getCurrentUserDetails();
    //     let customer = this.currentUser;
    //     customer.address = this.getAddress(customer);
    //     selectedInvoice['date'] = selectedInvoice['dateOfInvoice'];
    //     let gstTotal = this.calculateGSTInvoice(customer,selectedInvoice);
    //      await convertToSimpleInvoicePrint({
    //         invoiceData:selectedInvoice,
    //         firm: firm,
    //         customer : customer,
    //         gstTotal : gstTotal,
    //         terms : termsAndConditions[0]
    //       }).then((doc) => {
    //         pdfMake.createPdf(doc).download(this.buyerById(selectedInvoice.buyerId).name);
    //       });
    // },
    // End simple Print

    // Simple Print
    async printInvoice4(selectedInvoice){
      let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.accounts.filter(
              (item) => item[".key"] == bankId
            )[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firm
      )[0];
      firm.address = this.getAddress(firm);
      let customer = this.buyerById(selectedInvoice.buyerId);
      customer.address = this.getAddress(customer);
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
         await convertToSimpleInvoicePrint({
            invoiceData:selectedInvoice,
            firm: firm,
            customer : customer,
            gstTotal : gstTotal,
            terms : termsAndConditions[0],
            previousDue : [],
            estimates : []
          }).then((doc) => {
            pdfMake.createPdf(doc).download(this.buyerById(selectedInvoice.buyerId).name);
          });
    },

    // End of Simple Print

    // Temp of Dairy Invoice
    async printDairyInvoice(selectedInvoice) {
      let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.accounts.filter(
              (item) => item[".key"] == bankId
            )[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firm
      )[0];
      firm.address = this.getAddress(firm);
      let customer = this.buyerById(selectedInvoice.buyerId);
      customer.address = this.getAddress(customer);
      // selectedInvoice['date'] = selectedInvoice['dateOfInvoice'];
      let gstInvoice = firm.GST_user && firm.GST_user == "Yes" ? true : false;
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
      let productObj = {};
        if(!gstInvoice && termsAndConditions[0].isMajorUnitDisplay) {
          selectedInvoice.items.map((item)=>{
            productObj[item['productId']] =  this.productById[item['productId']];
          })
        }
      let doc = gstInvoice
        ? await convertToBasicInvoice({
            invoiceData: selectedInvoice,
            firm: firm,
            customer: customer,
            gstTotal: gstTotal,
            terms: termsAndConditions[0],
          })
        : await convertToBasicInvoiceForDairyWithoutGST({
            invoiceData: selectedInvoice,
            firm: firm,
            customer: customer,
            gstTotal: gstTotal,
            terms: termsAndConditions[0],
            productObj : productObj
          });
      pdfMake.createPdf(doc).download(this.buyerById(selectedInvoice.buyerId).name);
    },
    // Temp  of Dairy Invoice

    // Start of Dairy Invoice
    // async printDairyInvoice(selectedInvoice) {
    //   let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
    //   if (termsAndConditions.length) {
    //     if (termsAndConditions[0].bank) {
    //       let banks = [];
    //       termsAndConditions[0].bank.map((bankId) => {
    //         let bank = this.banks.filter((item) => item[".key"] == bankId)[0];

    //         bank.address = this.getAddress(bank);
    //         banks.push(bank);
    //       });
    //       termsAndConditions[0].banks = banks;
    //     } else {
    //       termsAndConditions[0].banks = [];
    //     }
    //   } else {
    //     termsAndConditions = [
    //       {
    //         termsAndConditions: "",
    //         banks: [],
    //       },
    //     ];
    //   }
    //   let firm = this.firms.filter(
    //     (item) => item[".key"] == selectedInvoice.firmID
    //   )[0];
    //   firm.address = this.getAddress(firm);
    //   this.getCurrentUserDetails();
    //   let customer = this.currentUser;
    //   customer.address = this.getAddress(customer);
    //   customer.stateCode = this.gState.filter(
    //     (item) => item.state == customer.state
    //   )[0].code;
    //   selectedInvoice["date"] = selectedInvoice["dateOfInvoice"];
    //   let gstInvoice = firm.GST_user && firm.GST_user == "Yes" ? true : false;
    //   let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
    //   let productObj = {};
    //   if(!gstInvoice && termsAndConditions[0].isMajorUnitDisplay) {
    //     selectedInvoice.items.map((item)=>{
    //       productObj[item['productId']] =  this.productById[item['productId']];
    //     })
    //   }
    //   let doc = gstInvoice
    //     ? await convertToBasicInvoice({
    //         invoiceData: selectedInvoice,
    //         firm: firm,
    //         customer: customer,
    //         gstTotal: gstTotal,
    //         terms: termsAndConditions[0],
    //         balance : this.getBalance,
    //       })
    //     : await convertToBasicInvoiceForDairyWithoutGST({
    //         invoiceData: selectedInvoice,
    //         firm: firm,
    //         customer: customer,
    //         gstTotal: gstTotal,
    //         terms: termsAndConditions[0],
    //         balance : this.getBalance,
    //         productObj : productObj
    //       });
    //   pdfMake.createPdf(doc).download(this.currentUser.name);
    // },
    // End of Dairy Invoice


    async printHorizontalInvoice(selectedInvoice){
      let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.accounts.filter(
              (item) => item[".key"] == bankId
            )[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firm
      )[0];
      firm.address = this.getAddress(firm);
      let customer = this.buyerById(selectedInvoice.buyerId);
      customer.address = this.getAddress(customer);
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
         await convertToBasicInvoiceHorizontal({
            invoiceData:selectedInvoice,
            firm: firm,
            customer : customer,
            gstTotal : gstTotal,
            terms : termsAndConditions[0]
          }).then((doc) => {
            pdfMake.createPdf(doc).download(this.buyerById(selectedInvoice.buyerId).name);
          });
    },
    printEwayType1(selectedInvoice){
              let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.accounts.filter(
              (item) => item[".key"] == bankId
            )[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firm
      )[0];
      firm.address = this.getAddress(firm);
      let customer = this.buyerById(selectedInvoice.buyerId);
      customer.address = this.getAddress(customer);
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
        let doc = convertToEwayBillType1({
            invoiceData:selectedInvoice,
            firm: firm,
            customer : customer,
            gstTotal : gstTotal,
            terms : termsAndConditions[0],
            ebillDetails : selectedInvoice.ewayBillDetails.ebillDetails,
            consignee : selectedInvoice.ewayBillDetails.consignee,
            transportationDetails : selectedInvoice.ewayBillDetails.transportationDetails,
          })
        pdfMake.createPdf(doc).download(this.buyerById(selectedInvoice.buyerId).name);
    },
    async printEwayType2(selectedInvoice){
              let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.accounts.filter(
              (item) => item[".key"] == bankId
            )[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firm
      )[0];
      firm.address = this.getAddress(firm);
      let customer = this.buyerById(selectedInvoice.buyerId);
      customer.address = this.getAddress(customer);
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
         await convertToEwayBillType2({
            invoiceData:selectedInvoice,
            firm: firm,
            customer : customer,
            gstTotal : gstTotal,
            terms : termsAndConditions[0],
             ebillDetails : selectedInvoice.ewayBillDetails.ebillDetails,
            consignee : selectedInvoice.ewayBillDetails.consignee,
            transportationDetails : selectedInvoice.ewayBillDetails.transportationDetails
          }).then((doc) => {
            pdfMake.createPdf(doc).download(this.buyerById(selectedInvoice.buyerId).name);
          });
    },
    async printEwayType3(selectedInvoice){
      let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.accounts.filter(
              (item) => item[".key"] == bankId
            )[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firm
      )[0];
      firm.address = this.getAddress(firm);
      let customer = this.buyerById(selectedInvoice.buyerId);
      customer.address = this.getAddress(customer);
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
         await convertToEwayBillType3({
            invoiceData:selectedInvoice,
            firm: firm,
            customer : customer,
            gstTotal : gstTotal,
            terms : termsAndConditions[0],
             ebillDetails : selectedInvoice.ewayBillDetails.ebillDetails,
            consignee : selectedInvoice.ewayBillDetails.consignee,
            transportationDetails : selectedInvoice.ewayBillDetails.transportationDetails
          }).then((doc) => {
            pdfMake.createPdf(doc).download(this.buyerById(selectedInvoice.buyerId).name);
          });
    },
    getTermsAndConditions(selectedInvoice) {
      return this.termsAndConditions.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["firm"] === selectedInvoice.firm
      );
    },
    getAddress(item) {
      let address =
        (item.village ? item.village + ", " : "") +
        (item.block ? item.block + ", " : "") +
        (item.tehsil ? item.tehsil + ", " : "") +
        (item.district ? item.district + ", " : "") +
        (item.state ? item.state + ", " : "") +
        (item.country ? item.country + ", " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    getGSTtotal(item) {
      let GSTTotal = 0;
      item &&
        item.items &&
        item.items.map((item) => {
          GSTTotal += Number.parseFloat(item.GSTValue);
        });
      return Number.parseFloat(GSTTotal);
    },
    calculateGSTInvoice(currentUser, invoice) {
      let SGST_val = 0;
      let CGST_val = 0;
      let IGST_val = 0;
      invoice.items &&
        invoice.items.map((item, index) => {
          SGST_val += parseFloat(item["SGST_val"]);
          CGST_val += parseFloat(item["CGST_val"]);
          IGST_val += parseFloat(item["IGST_val"]);
        });
      return { SGST_val, CGST_val, IGST_val };
    },

    firmNameById(id) {
      let firm = this.firms.filter((item) => item[".key"] == id)[0];
      if (firm) {
        return firm["name"];
      }
    },
    branchNameById(id) {
      let branch = this.branchs.filter((item) => item[".key"] == id)[0];
      if (branch) {
        return branch["branchName"];
      }
    },
    renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/SalePurchaseStatements/normalView.vue